// extracted by mini-css-extract-plugin
export var container = "styles-module--container--mzPSL";
export var heading = "styles-module--heading--jGBXM";
export var list = "styles-module--list--mI88y";